import { FormData } from '../../../types/forms';

export const validateSectionForSave = (section: string, field: string, value: any): string => {
  // Simple validation for save
  if (field === 'email' && value && !/\S+@\S+\.\S+/.test(value)) {
    return 'Invalid email format';
  }
  if (field === 'phone' && value && !/^\d{10,}$/.test(value)) {
    return 'Phone number should be at least 10 digits';
  }
  return '';
};

export const validateSectionForSubmit = (
  section: string,
  formData: FormData
): { isValid: boolean; errors: string[] } => {
  const errors: string[] = [];
  let isValid = true;

  if (section === 'personal') {
    if (!formData.personal.firstName) errors.push('First Name is required');
    if (!formData.personal.lastName) errors.push('Last Name is required');
    if (!formData.personal.email) errors.push('Email is required');
    if (!formData.personal.phone) errors.push('Phone is required');
    if (!formData.personal.dob) errors.push('Date of Birth is required');
    if (!formData.personal.addressLine1) errors.push('Address Line 1 is required');
    if (!formData.personal.addressLine2) errors.push('Address Line 2 is required');
    if (!formData.personal.city) errors.push('City is required');
    if (!formData.personal.county) errors.push('County is required');
    if (!formData.personal.postcode) errors.push('Postcode is required');
  } else if (section === 'counselling') {
    if (formData.counselling.languages.length === 0) errors.push('Languages is required');
    if (formData.counselling.sessionTypes.length === 0) errors.push('Session Types is required');
    if (formData.counselling.modality.length === 0) errors.push('Modality is required');
    if (!formData.counselling.experience) errors.push('Experience is required');
    // Availability is optional - detailed time slots can be specified instead
    if (!formData.counselling.cv) errors.push('CV is required');
  } else if (section === 'education') {
    if (!formData.education.courseName) errors.push('Course Name is required');
    if (!formData.education.learningInstitution) errors.push('Learning Institution is required');
    if (!formData.education.qualificationType) errors.push('Qualification Type is required');
    if (!formData.education.hoursCompleted) errors.push('Hours Completed is required');
  } else if (section === 'referee') {
    if (!formData.referee.firstReferee.name) errors.push('Profess ional Referee Name is required');
    if (!formData.referee.firstReferee.email) errors.push('Professional Referee Email is required');
    if (!formData.referee.firstReferee.mobile) errors.push('Professional Referee Mobile is required');
    if (!formData.referee.firstReferee.relationship) errors.push('Professional Referee Relationship is required');
    if (!formData.referee.secondReferee.name) errors.push('Personal Referee Name is required');
    if (!formData.referee.secondReferee.email) errors.push('Personal Referee Email is required');
    if (!formData.referee.secondReferee.mobile) errors.push('Personal Referee Mobile is required');
    if (!formData.referee.secondReferee.relationship) errors.push('Personal Referee Relationship is required');
  }

  if (errors.length > 0) {
    isValid = false;
  }

  return { isValid, errors };
};
